<template>
  <div class="home-root">
    <div v-if="!user.id" class="notification is-light">
      Загрузка…
    </div>

    <div v-else class="card">
      <div v-if="user.spaceship_image" class="card-image">
        <figure class="image is-16by9">
          <img :src="user.spaceship_image" alt="Местоположение">
        </figure>
      </div>

      <div class="card-content">
        <p class="title is-4">Где я</p>

        <div v-if="spaceship" class="content">
          <p class="subtitle is-5">{{ locationTitle }}</p>
          <p v-if="spaceship.body_name">
            <strong>Тело:</strong> {{ spaceship.body_name }}
          </p>
          <p v-if="spaceship.star_name">
            <strong>Звёздная система:</strong> {{ spaceship.star_name }}
          </p>
          <p v-if="spaceship.galaxy_name">
            <strong>Галактика:</strong> {{ spaceship.galaxy_name }}
          </p>
        </div>

        <div v-else class="notification is-warning is-light">
          Местоположение неизвестно
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    spaceship() {
      const location = this.user.user_location
      return location && location.spaceship ? location.spaceship : null
    },
    kindLabel() {
      const labels = {
        station: 'станции',
        ship: 'корабле',
        probe: 'зонде',
      }
      return labels[this.spaceship.kind] || 'объекте'
    },
    locationTitle() {
      if (!this.spaceship) return ''
      return `Вы на ${this.kindLabel} «${this.spaceship.name}»`
    },
  },
}
</script>

<style scoped>
.home-root {
  max-width: 640px;
  margin: 0 auto;
}
</style>
